import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css';

tippy('.glossify-tooltip-link', {
  content: (reference) => reference.dataset.tippyContent,
  allowHTML: true,
});